import { Component, OnInit } from '@angular/core';
import { VersionService } from '../../services/version.service';

@Component({
  selector: 'app-version-banner',
  templateUrl: './app-version-banner.component.html',
  styleUrls: ['./app-version-banner.component.scss']
})
export class AppVersionBannerComponent implements OnInit {

  public visible = false;

  constructor(private versionService: VersionService) {}

  ngOnInit(): void {
    this.versionService.isOldAppVersion$.subscribe(isOld => {
      this.visible = isOld;
    });
  }

  public onReload(): void {
    this.versionService.reloadApp();
  }

  public onDismiss(): void {
    this.versionService.dismissBanner();
  }

}
